export default __webpack_public_path__ + "static/media/11 - Dayspring.1a6461cd.mp3";